import AdminsSortPanel from './component'

export default AdminsSortPanel
